import { useNavigate } from 'react-router-dom';
import englishIllustration from '@/assets/children-waking-hours.svg';
import { ChildrenTranslatedIllustration } from './ChildrenTranslatedIllustration';
import styles from './ChildrensWakingHours.styles';
import {
  BodyLarge,
  ButtonPrimaryLarge,
  TitleMediumEmphasized
} from '@/design-system';
import { Subscription } from '@/graphql/types';
import { FlyerType } from '@/config/constants';
import { useContext } from 'react';
import UserPreferencesContext from '@/context/UserPreferencesContext';

type Props = {
  subscriptions: Subscription[];
}

export const ChildrensWakingHours: React.FC<Props> = ({ subscriptions }) => {
  const navigate = useNavigate();
  const { isEnglishLanguage  } = useContext(UserPreferencesContext);

  const onExploreAllOportunities = () => {
    if (!subscriptions) return;

    let audienceId = subscriptions.length > 1 ? 'all' : subscriptions[0].id;
    navigate(`explore/all?audienceId=${audienceId}&tab=${FlyerType.school}`);
  }

  return (
    <section className={styles.container}>
      <TitleMediumEmphasized>
        Children’s waking hours
      </TitleMediumEmphasized>
      <BodyLarge>
        Each year consists of about 6,000 waking
        hours. Children, on average, spend about 1,000
        of these waking hours in school.
      </BodyLarge>
      <div className={styles.content}>
          {isEnglishLanguage ? (
            <img
              src={englishIllustration}
              width="296px"
              height="248px"
              alt="Illustration showing a pie chart of a child's waking hours, divided into sections for family, community, and school. The chart highlights that about 5,000 hours are spent with family and community, while approximately 1,000 hours are spent in school."
              loading="lazy"
            />
          ) :
          <ChildrenTranslatedIllustration />
          }
        <BodyLarge>
          Thankfully, there are many school and
          community resources available beyond the
          classroom that help children stay active and
          find a path to potential!
        </BodyLarge>
        <ButtonPrimaryLarge onClick={onExploreAllOportunities}>
          Explore All Opportunities
        </ButtonPrimaryLarge>
      </div>
    </section>
  );
};

